import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import SessionHandler, { SessionFeatures } from 'SessionHandler'
import { isOnboardingRoute, isSecureDocUploaderRoute } from 'routing/routes'
import router from 'routing/router/index'
import { uploadFile } from 'utils/apiRequest'

// Session functions
const getSessionScope = (route) => {
  let scope = null
  if (isOnboardingRoute(route, false)) {
    scope = SessionFeatures.ONBOARDING
  } else if (isSecureDocUploaderRoute(route)) {
    scope = SessionFeatures.SECURE_DOC_UPLOADER
  }
  return scope
}

// End of session functions

class App extends Component {

  constructor (props) {
    super(props)
    this.state = {
      location: null,
      sessionScope: null,
    }
    window.sessionHandler = new SessionHandler()
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const newLocation = nextProps.location.type
    const newSessionScope = getSessionScope(newLocation)
    const oldSessionScope = prevState.sessionScope
    const isNewLocation = newLocation !== prevState.location

    if (newSessionScope) {
      if (oldSessionScope === null) {
        // We should start the 15 minute timeout.
        window.sessionHandler.initSession(newSessionScope)
      } else if (isNewLocation) {
        // Session scope is the same (We should refresh the session)
        window.sessionHandler.renewSession()
      }
    } else if (newSessionScope !== oldSessionScope) {
      // There is no session scope (Route does not require session). Just clear the session info
      window.sessionHandler.disableSession()
    }
    return {
      sessionScope: newSessionScope,
      location: newLocation
    }
  }

  componentWillUnmount () {
    window.sessionHandler.disableSession()
  }

  render () {
    const {
      siteNavOpen,
      isMobile,
      location
    } = this.props

    const route = location.type
    const Content = router[route]

    return (
      <Fragment>
        {Content && <Content
          {...this.props}
          hide={isMobile && siteNavOpen}
          uploadFile={uploadFile} />}
      </Fragment>
    )
  }

}

App.propTypes = {
  closeNav: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  siteNavOpen: PropTypes.bool.isRequired
}

export default App




// WEBPACK FOOTER //
// ./src/components/Onboarding/App/App.jsx